export const eyeIcon = (
	<svg
		width="13"
		height="12"
		viewBox="0 0 13 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_499_4296)">
			<path
				d="M12.0592 5.69008C12.0429 5.6532 11.6474 4.77596 10.7683 3.89686C9.59696 2.7255 8.11748 2.10645 6.48906 2.10645C4.86065 2.10645 3.38116 2.7255 2.2098 3.89686C1.3307 4.77596 0.933401 5.6546 0.918928 5.69008C0.897692 5.73784 0.886719 5.78954 0.886719 5.84181C0.886719 5.89408 0.897692 5.94577 0.918928 5.99354C0.935268 6.03042 1.3307 6.90719 2.2098 7.78629C3.38116 8.95718 4.86065 9.57624 6.48906 9.57624C8.11748 9.57624 9.59696 8.95718 10.7683 7.78629C11.6474 6.90719 12.0429 6.03042 12.0592 5.99354C12.0804 5.94577 12.0914 5.89408 12.0914 5.84181C12.0914 5.78954 12.0804 5.73784 12.0592 5.69008ZM6.48906 8.82926C5.05206 8.82926 3.79667 8.30684 2.75743 7.27694C2.33104 6.85288 1.96826 6.36933 1.68038 5.84134C1.96815 5.31328 2.33094 4.82972 2.75743 4.40574C3.79667 3.37584 5.05206 2.85342 6.48906 2.85342C7.92606 2.85342 9.18145 3.37584 10.2207 4.40574C10.6479 4.82965 11.0115 5.3132 11.3001 5.84134C10.9635 6.46974 9.49705 8.82926 6.48906 8.82926ZM6.48906 3.6004C6.04585 3.6004 5.61258 3.73183 5.24406 3.97807C4.87554 4.22431 4.58831 4.57429 4.4187 4.98377C4.24909 5.39325 4.20471 5.84383 4.29118 6.27853C4.37765 6.71323 4.59108 7.11252 4.90448 7.42593C5.21788 7.73933 5.61718 7.95275 6.05188 8.03922C6.48658 8.12569 6.93715 8.08131 7.34663 7.9117C7.75611 7.74209 8.1061 7.45486 8.35233 7.08634C8.59857 6.71782 8.73 6.28456 8.73 5.84134C8.72938 5.2472 8.49309 4.67757 8.07296 4.25744C7.65284 3.83732 7.08321 3.60102 6.48906 3.6004ZM6.48906 7.3353C6.19358 7.3353 5.90474 7.24768 5.65906 7.08352C5.41338 6.91937 5.2219 6.68604 5.10882 6.41306C4.99575 6.14007 4.96616 5.83969 5.02381 5.54989C5.08145 5.26009 5.22374 4.99389 5.43267 4.78495C5.64161 4.57602 5.9078 4.43373 6.1976 4.37609C6.4874 4.31844 6.78779 4.34803 7.06077 4.4611C7.33376 4.57418 7.56708 4.76566 7.73124 5.01134C7.8954 5.25702 7.98302 5.54587 7.98302 5.84134C7.98302 6.23757 7.82562 6.61756 7.54545 6.89773C7.26528 7.1779 6.88528 7.3353 6.48906 7.3353Z"
				fill="black"
				stroke="black"
				strokeWidth="0.280117"
			/>
		</g>
		<defs>
			<clipPath id="clip0_499_4296">
				<rect
					width="11.2047"
					height="11.2047"
					fill="white"
					transform="translate(0.886719 0.23877)"
				/>
			</clipPath>
		</defs>
	</svg>
)

export const chatIcon = (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_499_4298)">
			<path
				d="M4.10612 4.90728C4.10612 4.78347 4.1553 4.66473 4.24285 4.57718C4.3304 4.48963 4.44914 4.44045 4.57295 4.44045H7.37398C7.49779 4.44045 7.61653 4.48963 7.70408 4.57718C7.79163 4.66473 7.84082 4.78347 7.84082 4.90728C7.84082 5.0311 7.79163 5.14984 7.70408 5.23739C7.61653 5.32494 7.49779 5.37412 7.37398 5.37412H4.57295C4.44914 5.37412 4.3304 5.32494 4.24285 5.23739C4.1553 5.14984 4.10612 5.0311 4.10612 4.90728ZM4.57295 6.3078C4.44914 6.3078 4.3304 6.35698 4.24285 6.44453C4.1553 6.53208 4.10612 6.65082 4.10612 6.77463C4.10612 6.89845 4.1553 7.01719 4.24285 7.10474C4.3304 7.19229 4.44914 7.24147 4.57295 7.24147H6.4403C6.56412 7.24147 6.68286 7.19229 6.77041 7.10474C6.85796 7.01719 6.90714 6.89845 6.90714 6.77463C6.90714 6.65082 6.85796 6.53208 6.77041 6.44453C6.68286 6.35698 6.56412 6.3078 6.4403 6.3078H4.57295ZM0.371416 5.84096C0.371654 4.60762 0.778895 3.40883 1.52997 2.43055C2.28104 1.45227 3.33395 0.749199 4.52537 0.430389C5.7168 0.111578 6.98013 0.194855 8.1194 0.667301C9.25866 1.13975 10.2102 1.97495 10.8263 3.04335C11.4425 4.11176 11.6888 5.35363 11.5272 6.57633C11.3655 7.79903 10.8049 8.93421 9.93223 9.80577C9.05958 10.6773 7.92371 11.2365 6.7008 11.3967C5.4779 11.5568 4.23634 11.3089 3.16871 10.6914L0.985774 11.4197C0.905125 11.4466 0.818654 11.451 0.735693 11.4324C0.652732 11.4137 0.576432 11.3728 0.515027 11.314C0.453622 11.2552 0.409444 11.1807 0.387262 11.0987C0.365079 11.0166 0.365734 10.93 0.389156 10.8483L1.05393 8.52247C0.605787 7.69977 0.371124 6.77781 0.371416 5.84096ZM5.97347 1.17258C5.1492 1.17253 4.33961 1.39072 3.62701 1.80497C2.9144 2.21922 2.32417 2.81476 1.91632 3.53105C1.50848 4.24734 1.29755 5.05885 1.30499 5.88308C1.31242 6.70731 1.53796 7.51488 1.95866 8.2237C1.99103 8.27845 2.01187 8.33925 2.0199 8.40234C2.02793 8.46544 2.02297 8.52952 2.00535 8.59063L1.53011 10.2526L3.07814 9.73718C3.14388 9.71524 3.21369 9.70822 3.28249 9.71662C3.35128 9.72501 3.41735 9.74863 3.47588 9.78574C4.08769 10.1729 4.78118 10.4125 5.50152 10.4855C6.22186 10.5586 6.94932 10.463 7.62638 10.2065C8.30345 9.94998 8.91157 9.53948 9.40267 9.00746C9.89378 8.47545 10.2544 7.83649 10.456 7.1411C10.6577 6.44571 10.6948 5.71295 10.5645 5.00074C10.4342 4.28853 10.14 3.61639 9.70521 3.03746C9.27041 2.45852 8.7069 1.98865 8.05924 1.66499C7.41157 1.34133 6.6975 1.17275 5.97347 1.17258Z"
				fill="black"
				stroke="black"
				strokeWidth="0.280117"
			/>
		</g>
		<defs>
			<clipPath id="clip0_499_4298">
				<rect
					width="11.2047"
					height="11.2047"
					fill="white"
					transform="translate(0.371094 0.23877)"
				/>
			</clipPath>
		</defs>
	</svg>
)

export const arrowLeftIcon = (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.7086 14.8479L6.1427 10.282C5.60347 9.74275 5.60347 8.86038 6.1427 8.32116L10.7086 3.75525"
			stroke="#6C6C6C"
			strokeWidth="1.40058"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export const arrowRightIcon = (
	<svg
		width="38"
		height="38"
		viewBox="0 0 38 38"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			width="37.3489"
			height="37.3489"
			transform="translate(0.488281 0.626953)"
			fill="white"
		/>
		<path
			d="M17 24.8479L21.5659 20.282C22.1051 19.7427 22.1051 18.8604 21.5659 18.3212L17 13.7552"
			stroke="#6C6C6C"
			strokeWidth="1.40058"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export const pencilIcon = (
	<svg
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.9327 5.06917C14.1733 4.82859 14.1733 4.42762 13.9327 4.19937L12.4892 2.75588C12.261 2.51529 11.86 2.51529 11.6194 2.75588L10.4844 3.88476L12.7977 6.19806M3.00781 11.3675V13.6808H5.32111L12.1438 6.85195L9.83049 4.53866L3.00781 11.3675Z"
			fill="black"
		/>
	</svg>
)

export const deleteIcon = (
	<svg
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12.5625 12.1282L4.5625 4.12817M4.5625 12.1282L12.5625 4.12817"
			stroke="#240B3B"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export const trashIcon = <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M8.87946 2.79564L8.56946 7.80814C8.49046 9.08864 8.45096 9.72914 8.12946 10.1896C7.97074 10.4172 7.76641 10.6093 7.52946 10.7536C7.05096 11.0456 6.40946 11.0456 5.12646 11.0456C3.84146 11.0456 3.19896 11.0456 2.71946 10.7531C2.4824 10.6085 2.27806 10.4161 2.11946 10.1881C1.79846 9.72714 1.75946 9.08564 1.68246 7.80314L1.37946 2.79564M0.629456 2.79564H9.62946M7.15746 2.79564L6.81596 2.09164C6.58946 1.62364 6.47596 1.39014 6.28046 1.24414C6.23703 1.2118 6.19104 1.18304 6.14296 1.15814C5.92646 1.04564 5.66646 1.04564 5.14696 1.04564C4.61396 1.04564 4.34746 1.04564 4.12696 1.16264C4.07821 1.18874 4.03172 1.21885 3.98796 1.25264C3.79046 1.40414 3.67996 1.64664 3.45896 2.13114L3.15596 2.79564M3.87946 8.29564V5.29564M6.37946 8.29564V5.29564" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
</svg>


export const checkIcon = (
	<svg
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4.5 9.5L7.5 12.5L12.5 5.5"
			stroke="#240B3B"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export const downloadIcon = (
	<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.17578 0.45166C6.2868 0.45166 6.39328 0.495763 6.47178 0.574267C6.55028 0.65277 6.59439 0.759244 6.59439 0.870265V6.99473L7.53206 5.90022C7.56783 5.85844 7.61148 5.82412 7.66051 5.79921C7.70954 5.77429 7.763 5.75929 7.81784 5.75504C7.87267 5.75079 7.92781 5.75738 7.98009 5.77444C8.03238 5.79149 8.08079 5.81868 8.12257 5.85445C8.16435 5.89022 8.19868 5.93387 8.22359 5.9829C8.2485 6.03193 8.2635 6.08539 8.26776 6.14023C8.27201 6.19506 8.26541 6.2502 8.24835 6.30248C8.2313 6.35477 8.20411 6.40318 8.16834 6.44496L6.49392 8.39845C6.45462 8.44441 6.40584 8.4813 6.35092 8.5066C6.296 8.5319 6.23625 8.545 6.17578 8.545C6.11532 8.545 6.05557 8.5319 6.00065 8.5066C5.94573 8.4813 5.89694 8.44441 5.85764 8.39845L4.18322 6.44496C4.14745 6.40318 4.12027 6.35477 4.10321 6.30248C4.08615 6.2502 4.07956 6.19506 4.08381 6.14023C4.08806 6.08539 4.10307 6.03193 4.12798 5.9829C4.15289 5.93387 4.18721 5.89022 4.22899 5.85445C4.27077 5.81868 4.31918 5.79149 4.37147 5.77444C4.42376 5.75738 4.47889 5.75079 4.53373 5.75504C4.58856 5.75929 4.64202 5.77429 4.69105 5.79921C4.74009 5.82412 4.78373 5.85844 4.8195 5.90022L5.75718 6.99417V0.870265C5.75718 0.759244 5.80128 0.65277 5.87978 0.574267C5.95829 0.495763 6.06476 0.45166 6.17578 0.45166ZM3.38285 4.35975C3.49387 4.35916 3.60058 4.4027 3.6795 4.48078C3.75843 4.55887 3.8031 4.6651 3.80369 4.77613C3.80428 4.88715 3.76075 4.99386 3.68266 5.07278C3.60458 5.1517 3.49834 5.19637 3.38732 5.19696C2.77727 5.20031 2.34471 5.21594 2.01597 5.27622C1.70006 5.33482 1.51643 5.42803 1.3808 5.56366C1.2262 5.71827 1.12573 5.93538 1.07048 6.34506C1.01411 6.76645 1.01299 7.32515 1.01299 8.12608V8.68422C1.01299 9.48571 1.01411 10.0444 1.07048 10.4658C1.12573 10.8755 1.22676 11.092 1.3808 11.2472C1.53541 11.4012 1.75197 11.5017 2.1622 11.557C2.58304 11.6139 3.14229 11.6145 3.94322 11.6145H8.40834C9.20927 11.6145 9.76797 11.6139 10.1899 11.557C10.5996 11.5017 10.8162 11.4012 10.9708 11.2466C11.1254 11.092 11.2258 10.8755 11.2811 10.4658C11.3375 10.0444 11.3386 9.48571 11.3386 8.68422V8.12608C11.3386 7.32515 11.3375 6.76645 11.2811 6.3445C11.2258 5.93538 11.1248 5.71827 10.9708 5.56366C10.8346 5.42803 10.6515 5.33482 10.3356 5.27622C10.0069 5.21594 9.57429 5.20031 8.96425 5.19696C8.90928 5.19667 8.8549 5.18555 8.80422 5.16424C8.75355 5.14294 8.70757 5.11186 8.6689 5.07278C8.63024 5.0337 8.59965 4.98739 8.57888 4.93649C8.55812 4.88559 8.54758 4.8311 8.54787 4.77613C8.54817 4.72115 8.55929 4.66678 8.58059 4.6161C8.6019 4.56543 8.63298 4.51944 8.67206 4.48078C8.71114 4.44212 8.75745 4.41153 8.80835 4.39076C8.85925 4.37 8.91374 4.35946 8.96871 4.35975C9.57262 4.3631 10.0755 4.37761 10.4869 4.45296C10.9099 4.5311 11.2699 4.67901 11.5629 4.97203C11.8989 5.30747 12.0429 5.7311 12.111 6.23343C12.1758 6.71678 12.1758 7.3324 12.1758 8.09538V8.71492C12.1758 9.47845 12.1758 10.0935 12.111 10.5774C12.0429 11.0798 11.8989 11.5028 11.5629 11.8388C11.2269 12.1748 10.8039 12.3188 10.3015 12.3869C9.81764 12.4517 9.20201 12.4517 8.43904 12.4517H3.91253C3.14955 12.4517 2.53392 12.4517 2.05001 12.3869C1.54769 12.3194 1.12462 12.1748 0.788619 11.8388C0.452619 11.5028 0.308618 11.0798 0.241084 10.5774C0.175781 10.0935 0.175781 9.47789 0.175781 8.71492V8.09538C0.175781 7.3324 0.175781 6.71678 0.241084 6.23287C0.30806 5.73054 0.453177 5.30747 0.788619 4.97147C1.08164 4.67901 1.44164 4.53054 1.86471 4.45296C2.27606 4.37761 2.77894 4.3631 3.38285 4.35975Z" fill="black" />
	</svg>

)

export const viewBreaksIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M9.03776 4.97933V6.646C8.05685 6.64603 7.09761 6.9346 6.27948 7.47576C5.46135 8.01692 4.82047 8.78678 4.43664 9.68947C4.0528 10.5922 3.94296 11.5878 4.1208 12.5525C4.29864 13.5171 4.7563 14.4082 5.43679 15.1147C6.11729 15.8212 6.99056 16.3119 7.94788 16.5257C8.90519 16.7396 9.90427 16.6671 10.8207 16.3174C11.7372 15.9676 12.5305 15.356 13.1019 14.5588C13.6733 13.7615 13.9976 12.8137 14.0344 11.8335L14.0378 11.646H15.7044C15.7044 13.4141 15.002 15.1098 13.7518 16.36C12.5016 17.6103 10.8059 18.3127 9.03776 18.3127C7.26965 18.3127 5.57396 17.6103 4.32372 16.36C3.07347 15.1098 2.37109 13.4141 2.37109 11.646C2.37109 8.0335 5.35443 4.97933 9.03776 4.97933ZM17.3711 1.646V3.31266L12.9319 8.31266H17.3711V9.97933H10.7044V8.31266L15.1428 3.31266H10.7044V1.646H17.3711Z" fill="black" />
</svg>

export const cancelIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="black" className="size-4">
	<path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
</svg>

export const saveIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="black" class="size-4">
	<path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
</svg>
